module.exports = __webpack_public_path__ + "img/sp_article_11.4d6a97ce.jpg";